<h1 mat-dialog-title>Version info</h1>
<div mat-dialog-content>
  <div class="container">
    <h2>Employee UI</h2>
    <div class="row ">
      <div class="col-sm-4"><b>Commit</b></div>
      <div class="col-sm-8">{{data.uiInfo?.commit}}</div>
    </div>
    <div class="row ">
      <div class="col-sm-4"><b>Build #</b></div>
      <div class="col-sm-8">{{data.uiInfo?.buildNo}}</div>
    </div>
    <div class="row ">
      <div class="col-sm-4"><b>Branch</b></div>
      <div class="col-sm-8">{{data.uiInfo?.branch}}</div>
    </div>
  </div>
  <hr class="hr-top-15"/>
  <div class="container padding-top-15">
    <h2>Revenue APP</h2>
    <div class="row ">
      <div class="col-sm-4"><b>Commit</b></div>
      <div class="col-sm-8">{{data.appInfo?.git?.commit?.id}}</div>
    </div>
    <div class="row ">
      <div class="col-sm-4"><b>Build #</b></div>
      <div class="col-sm-8">{{data.appInfo?.build?.build_number}}</div>
    </div>
    <div class="row ">
      <div class="col-sm-4"><b>Branch</b></div>
      <div class="col-sm-8">{{data.appInfo?.git?.branch}}</div>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
</div>
